import { render, staticRenderFns } from "./AddEventModal.vue?vue&type=template&id=f1a327b6"
import script from "./AddEventModal.vue?vue&type=script&lang=js"
export * from "./AddEventModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports